import React, { Component } from "react";
import FadeIn from "react-fade-in";
import { Col, Row } from "react-flexbox-grid";
import {
  Card,
  Loader,
  TabsCustom,
  TabsCustomHeader,
  TabsCustomBody,
  TabsCustomMenu,
  TabsCustomItem,
  FormRadio,
} from "ui-kit-ck-consultant";

import CardTechnical from "./CardTechnical";
import CardQuality from "./CardQuality";
import CardSpeciality from "./CardSpeciality";
import CardTable from "./CardTable";
import AlphaScale from "../AXA/AlphaScale";

import axiosConfig from "../../../../../utils/axiosConfig";

import AuthContext from "../../../../../context/AuthContext";

export default class CardACM extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataGeneral: null,
      dataTable: null,
      dataAlphaScale: null,
      dataAlphaScaleOld: null,
      dataAlphaScaleMonth: null,
      isLoadGeneral: false,
      isLoadTable: false,
      isLoad: false,
      approved: null,
      tabsData: [
        "Général",
        "AlphaScale Agence",
        "AlphaScale Expert",
        "AlphaScale Réparateur",
        "AlphaScale Département",
      ],
      tabsIndex: 0,
    };
  }

  static contextType = AuthContext;

  componentDidMount() {
    this.getPerformanceGeneral();
    this.getPerformanceTable();

    if (this.context.group !== 1 && this.context.network) {
      this.setState({ tabsData: ["Général"] });
    }
  }

  componentDidUpdate = (prevProps) => {
    if (
      JSON.stringify(prevProps.data) !== JSON.stringify(this.props.data) &&
      parseInt(this.props.data.company) === 5
    ) {
      this.setState(
        {
          dataAlphaScale: null,
          dataAlphaScaleOld: null,
          tabsIndex: 0,
        },
        () => {
          this.getPerformanceGeneral();
          this.getPerformanceTable();
        }
      );
    }
  };

  getData = () => {
    return {
      dateStart: this.props.data.dateStart,
      dateEnd: this.props.data.dateEnd,
      network: this.props.data.network,
      group: this.props.data.group,
      region: this.props.data.region,
      agency: this.props.data.agency,
      user: this.props.data.user,
      company: this.props.data.company,
      approved: this.state.approved,
      darvaCode: this.props.data.darvaCode,
    };
  };

  getPerformanceGeneral = () => {
    this.setState({ isLoadGeneral: true }, () => {
      axiosConfig("/company-performance/acm-general", {
        data: this.getData(),
      }).then((res, err) => {
        if (res.data.success) {
          this.setState({ dataGeneral: res.data.data, isLoadGeneral: false });
        } else {
          this.setState({ dataGeneral: null, isLoadGeneral: false });
        }
      });
    });
  };

  getPerformanceTable = () => {
    this.setState({ isLoadTable: true }, () => {
      axiosConfig("/company-performance/acm-table", {
        data: this.getData(),
      }).then((res, err) => {
        if (res.data.success) {
          this.setState({ dataTable: res.data.data, isLoadTable: false });
        } else {
          this.setState({ dataTable: null, isLoadTable: false });
        }
      });
    });
  };

  getAlphaScale = () => {
    this.setState({ isLoad: true }, () => {
      axiosConfig("/company-performance/acm-alphascale", {
        data: this.getData(),
      })
        .then((res) => {
          if (res.data.success) {
            this.setState({
              dataAlphaScale: res.data.data,
              dataAlphaScaleOld: res.data.dataOld,
              dataAlphaScaleMonth: res.data.dataMonth,
              isLoad: false,
            });
          } else {
            this.setState({
              dataAlphaScale: null,
              dataAlphaScaleOld: null,
              isLoad: false,
            });
          }
        })
        .catch(() => {
          this.setState({
            dataAlphaScale: null,
            dataAlphaScaleOld: null,
            isLoad: false,
          });
        });
    });
  };

  render() {
    return (
      <>
        {this.state.tabsIndex !== 0 ? (
          <Card title="Filtres" className={"mt-10 mb-20-xl"}>
            <div className="d-flex mb-10">
              <FormRadio
                className="mr-10"
                checked={this.state.approved === null}
                text={"Tous les réparateurs"}
                onChange={() =>
                  this.setState({ approved: null }, this.getAlphaScale)
                }
              />
              <FormRadio
                className="mr-10"
                checked={this.state.approved === true}
                text={"Réparateurs agrés"}
                onChange={() =>
                  this.setState({ approved: true }, this.getAlphaScale)
                }
              />
              <FormRadio
                className="mr-10"
                checked={this.state.approved === false}
                text={"Réparateurs non agrés"}
                onChange={() =>
                  this.setState({ approved: false }, this.getAlphaScale)
                }
              />
            </div>
          </Card>
        ) : null}
        <TabsCustom>
          <TabsCustomHeader>
            {this.state.tabsData.map((element, idx) => (
              <TabsCustomMenu
                key={idx}
                title={element}
                active={this.state.tabsIndex === idx}
                disabled={!this.state.tabsData[idx]}
                onClick={() => {
                  if (this.state.tabsIndex !== idx) {
                    this.setState({ tabsIndex: idx }, () => {
                      if (
                        this.state.tabsIndex === 0 &&
                        !this.state.dataGeneral
                      ) {
                        this.getPerformanceGeneral();
                        this.getPerformanceTable();
                      } else if (
                        (this.state.tabsIndex === 1 ||
                          this.state.tabsIndex === 2 ||
                          this.state.tabsIndex === 3 ||
                          this.state.tabsIndex === 4) &&
                        !this.state.dataAlphaScale
                      ) {
                        this.getAlphaScale();
                      }
                    });
                  }
                }}
              />
            ))}
          </TabsCustomHeader>
          <TabsCustomBody noCard>
            <TabsCustomItem active={this.state.tabsIndex === 0}>
              <FadeIn>
                <Row>
                  <Col xs={12} lg={6}>
                    <CardTechnical data={this.state.dataGeneral} />
                  </Col>
                  <Col xs={12} lg={6}>
                    <CardQuality data={this.state.dataGeneral} />
                  </Col>
                  <Col xs={12}>
                    <CardSpeciality data={this.state.dataGeneral} />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={12} lg={12} className={"mt-30"}>
                    <CardTable data={this.state.dataTable} />
                  </Col>
                </Row>
              </FadeIn>
            </TabsCustomItem>
            <TabsCustomItem active={this.state.tabsIndex === 1}>
              <AlphaScale
                total={
                  this.state.dataAlphaScale &&
                  this.state.dataAlphaScale.total[0]
                    ? this.state.dataAlphaScale.total[0]
                    : {}
                }
                totalCSV={
                  this.state.dataAlphaScale
                    ? this.state.dataAlphaScale.totalCSV
                    : {}
                }
                data={
                  this.state.dataAlphaScale
                    ? this.state.dataAlphaScale.agency
                    : []
                }
                dataOld={
                  this.state.dataAlphaScaleOld
                    ? this.state.dataAlphaScaleOld.agency
                    : []
                }
                dataMonth={this.state.dataAlphaScaleMonth}
                isPrint={this.props.isPrint}
              />
            </TabsCustomItem>
            <TabsCustomItem active={this.state.tabsIndex === 2}>
              <AlphaScale
                total={
                  this.state.dataAlphaScale &&
                  this.state.dataAlphaScale.total[0]
                    ? this.state.dataAlphaScale.total[0]
                    : {}
                }
                totalCSV={
                  this.state.dataAlphaScale
                    ? this.state.dataAlphaScale.totalCSV
                    : {}
                }
                data={
                  this.state.dataAlphaScale
                    ? this.state.dataAlphaScale.expert
                    : []
                }
                dataOld={
                  this.state.dataAlphaScaleOld
                    ? this.state.dataAlphaScaleOld.expert
                    : []
                }
                dataMonth={this.state.dataAlphaScaleMonth}
                isPrint={this.props.isPrint}
              />
            </TabsCustomItem>
            <TabsCustomItem active={this.state.tabsIndex === 3}>
              <AlphaScale
                total={
                  this.state.dataAlphaScale &&
                  this.state.dataAlphaScale.total[0]
                    ? this.state.dataAlphaScale.total[0]
                    : {}
                }
                totalCSV={
                  this.state.dataAlphaScale
                    ? this.state.dataAlphaScale.totalCSV
                    : {}
                }
                data={
                  this.state.dataAlphaScale
                    ? this.state.dataAlphaScale.garage
                    : []
                }
                dataOld={
                  this.state.dataAlphaScaleOld
                    ? this.state.dataAlphaScaleOld.garage
                    : []
                }
                dataMonth={this.state.dataAlphaScaleMonth}
                isPrint={this.props.isPrint}
              />
            </TabsCustomItem>
            <TabsCustomItem active={this.state.tabsIndex === 4}>
              <AlphaScale
                total={
                  this.state.dataAlphaScale &&
                  this.state.dataAlphaScale.total[0]
                    ? this.state.dataAlphaScale.total[0]
                    : {}
                }
                totalCSV={
                  this.state.dataAlphaScale
                    ? this.state.dataAlphaScale.totalCSV
                    : {}
                }
                data={
                  this.state.dataAlphaScale
                    ? this.state.dataAlphaScale.department
                    : []
                }
                dataOld={
                  this.state.dataAlphaScaleOld
                    ? this.state.dataAlphaScaleOld.department
                    : []
                }
                dataMonth={this.state.dataAlphaScaleMonth}
                isPrint={this.props.isPrint}
              />
            </TabsCustomItem>
          </TabsCustomBody>
        </TabsCustom>

        <Loader
          show={
            this.state.isLoadGeneral ||
            this.state.isLoadTable ||
            this.state.isLoad
          }
        />
      </>
    );
  }
}
